const MultiEventBetBuilderBannerLocation = {
    Home: 'home',
    Prematch: 'prematch',
} as const;
type MultiEventBetBuilderBannerLocation = typeof MultiEventBetBuilderBannerLocation[keyof typeof MultiEventBetBuilderBannerLocation];

export { MultiEventBetBuilderBannerLocation };
